import React from 'react'
import MySpiner from '../../../../UI/spiner/MySpiner'
import { useState } from 'react'
import ScannerWrap from '../../../../scanner/ScannerWrap'
import { useEffect } from 'react'
import { setValueForm } from '../../../../../helpers/form/FormHelper'
import PackingGoodGetSeriesData from '../PackingGoodGetSeriesData'

const PackingGoodFieldScaner = ({ valueScan, setValueScan, reset, setReset, header, goodType, goodsFromBd, setGoodsFromBd }) => {

    // const [loading, setLoading] = useState(false)
    // const [error, setError] = useState('')

  return (
    <div className='seriesRead'>
        <h4>
            {header}
        </h4>

        <ScannerWrap
            setResultText={e => {
                // setScanResultTemp(e)
                // setScannedGood(e)
                setValueScan(e)
            }}
            reset={reset}
            setReset={setReset}
        />


        {
            valueScan ? 
                <div className='success'>
                    Результат сканування: {valueScan}
                </div>
            : ''
        }

        {
            valueScan ?
                <>
                    <PackingGoodGetSeriesData 
                        goodType={goodType}
                        goodsFromBd={goodsFromBd}
                        setGoodsFromBd={setGoodsFromBd}
                        valueScan={valueScan}
                    />
                </>
            : ''
        }

        {/* {
            loading ? <MySpiner /> : ''
        }

        {
            error ? 
                <div className='error'>
                    {error}
                </div>
            : ''
        } */}

    </div>
  )
}

export default PackingGoodFieldScaner